<div *ngIf="privateBadge" class="private-badge">
    <span class="badge badge-danger">{{ "item.badge.private" | translate }}</span>
</div>
<div *ngIf="withdrawnBadge" class="withdrawn-badge">
    <span class="badge badge-warning">{{ "item.badge.withdrawn" | translate }}</span>
</div>
